import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { modalCancelableAtom } from '@states/uiAtoms';
import { useAtomValue } from 'jotai/index';
import {
    ReactNode, useEffect, useRef,
} from 'react';
import { createPortal } from 'react-dom';

interface Props {
    isOpen: boolean;
    close: () => void;
    // title?: string;
    children?: ReactNode;
    // footerDirection?: 'row' | 'column-reverse';
    // confirmText?: string;
    // confirmDisabled?: boolean;
    // onConfirm?: () => void;
    // cancelDisabled?: boolean;
    // cancelText?: string;
    // containerClassName?: string;
}

function ModalComponent(props: Props) {
    const {
        isOpen, close, children,
    } = props;
    const bgRef = useRef<HTMLDivElement>(null);
    const cancelable = useAtomValue(modalCancelableAtom);

    /*
  const handleConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    close();
    // onConfirm?.();
  };

   */

    useEffect(() => {
        if (isOpen) {
            bgRef.current?.classList.remove(styles.none);
            const showTimeout = setTimeout(() => {
                bgRef.current?.classList.remove(styles.hide);
            }, 50);
            return () => clearTimeout(showTimeout);
        }
        bgRef.current?.classList.add(styles.hide);
        const closeTimeout = setTimeout(() => {
            bgRef.current?.classList.add(styles.none);
        }, 200);
        return () => clearTimeout(closeTimeout);
    }, [isOpen]);

    return (<div ref={bgRef}
        className={`${styles.background} ${styles.none} ${styles.hide}`}
        onClick={() => {
            if (cancelable) {
                close();
            }
        }}>

        <Container onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
        }} >
            {children}
            {/*
            {title && (
                <Text size='xl'
                      fontWeight='bold'
                      className={styles.title}>
                    {title}
                </Text>
            )}
            <Column spacing={28}
                    align='center'
                    fullWidth>
                {children}
                <footer className={styles.footer}
                        style={{ flexDirection: footerDirection }}>
                    {(!cancelDisabled) && (
                        <Button variant='secondary'
                                fullWidth
                                size='sm'
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  close();
                                }}>
                            {cancelText ?? '취소'}
                        </Button>
                    )
                    }
                    {onConfirm && (
                        <Button size='sm'
                                fullWidth
                                disabled={confirmDisabled}
                                onClick={handleConfirm}>
                            {confirmText ?? '확인'}
                        </Button>
                    )}
                </footer>
            </Column>
*/}
        </Container>
    </div>);
}

function Modal(props: Props) {
    return createPortal(<ModalComponent {...props} />, document.body);
}

// useEffect에서 classList로 토글하는 상태 클래스
const HIDE = 'hide';
const NONE = 'none';

const background = css`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    height: 100vh;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity linear 200ms;
    width: 100vw;
    z-index: 10000;

    &.${HIDE} {
        opacity: 0;

        > div {
            transform: translateY(10vh);
        }
    }

    &.${NONE} {
        display: none;
    }
`;

const styles = {
    background, hide: HIDE, none: NONE,
};

const Container = styled.div`
    align-items: center;
    background-color: var(--color-white);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    max-width: calc(var(--max-view-port-width) - 40px);
    padding: 20px 18px;
    transition: transform ease-out 200ms;
    width: calc(100% - 40px);
`;

export default Modal;
